module.exports = __webpack_public_path__ + "static/media/IMG_3474_sm.52ee223e.jpg";